"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useValidators = void 0;
var _reactI18next = require("react-i18next");
var _bignumber = require("bignumber.js");
var _libphonenumberJs = require("libphonenumber-js");
var _metadataMin = _interopRequireDefault(require("libphonenumber-js/metadata.min.json"));
var _dateHelper = require("../helpers/dateHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getTimeObj = function getTimeObj(date) {
  return {
    hours: date.getHours(),
    minutes: date.getMinutes()
  };
};
var useValidators = exports.useValidators = function useValidators() {
  var _useTranslation = (0, _reactI18next.useTranslation)('translation'),
    t = _useTranslation.t;
  return {
    required: function required(value) {
      return value ? undefined : t('Required');
    },
    notDefault: function notDefault(value) {
      return value !== 'default' ? undefined : t('Required');
    },
    requiredNumeric: function requiredNumeric(value) {
      return value !== undefined && value !== '' ? undefined : t('Required');
    },
    matchingPassword: function matchingPassword(value, allValues) {
      return value !== allValues.password ? t('Passwords do not match') : undefined;
    },
    email: function email(value) {
      return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? t('Invalid email address') : undefined;
    },
    validateReceiverEmail: function validateReceiverEmail(value, userEmail) {
      return value === userEmail ? t("You can't use your own email as receiver address") : undefined;
    },
    noWhiteSpace: function noWhiteSpace(value) {
      return value && /\s/.test(value) ? t('Must not contain whitespace') : undefined;
    },
    alphanumeric: function alphanumeric(value) {
      return value && !/^[a-z0-9]*$/i.test(value) ? t('Input should only contain alphanumeric characters') : undefined;
    },
    alphabetic: function alphabetic(value) {
      return value && !/^[a-z]*$/i.test(value) ? t('Input should only contain alphabetic characters') : undefined;
    },
    alphanumericspace: function alphanumericspace(value) {
      return !/^[a-z\d\s]*$/i.test(value) ? t('Input should only contain alphanumeric and space characters') : undefined;
    },
    numeric: function numeric(value) {
      return value && !/^\d*$/i.test(value) ? t('Input should only contain numeric characters') : undefined;
    },
    greaterThanValue: function greaterThanValue(min) {
      return function (value) {
        return value !== undefined && value <= min ? t('Must be greater than {{a}}', {
          a: min
        }) : undefined;
      };
    },
    greaterThanOrEqualToValue: function greaterThanOrEqualToValue(min) {
      return function (value) {
        return value !== undefined && value !== '' && value < min ? t('Must be greater than or equal to {{a}}', {
          a: min
        }) : undefined;
      };
    },
    lessThanValue: function lessThanValue(max) {
      return function (value) {
        return value && value > max ? t('Must be less than {{a}}', {
          a: max
        }) : undefined;
      };
    },
    allowedNumberValuesRange: function allowedNumberValuesRange(min, max) {
      return function (value) {
        var formattedValue = new _bignumber.BigNumber(value);
        var formattedMaxValue = new _bignumber.BigNumber(max);
        return typeof value !== 'undefined' && (formattedValue.isLessThanOrEqualTo(min) || formattedValue.isGreaterThanOrEqualTo(formattedMaxValue)) ? t('Allowed value must be greater than {{a}} and less than {{b}}', {
          a: min,
          b: max
        }) : undefined;
      };
    },
    greaterThanZero: function greaterThanZero(value) {
      return value !== undefined && value <= 0 ? t('Must be greater than {{a}}', {
        a: 0
      }) : undefined;
    },
    greaterThanOrEqualToZero: function greaterThanOrEqualToZero(value) {
      return value !== undefined && value < 0 ? t('Must be greater than or equal to {{a}}', {
        a: 0
      }) : undefined;
    },
    validatePassword: function validatePassword(value) {
      return value && !value.match(window.APEXWebConfig.global.PasswordRegexPattern) ? window.APEXWebConfig.global.DefaultPasswordRegexErrorMessage : undefined;
    },
    isDate: function isDate(value) {
      var isInvalid = Object.prototype.toString.call(value) === '[object Date]' ? isNaN(value.getTime()) : true;
      return value && isInvalid ? t('Invalid date') : undefined;
    },
    maxLength: function maxLength(max) {
      return function (value) {
        return value && value.length > max ? t('Must be {{a}} characters or less', {
          a: max
        }) : undefined;
      };
    },
    minLength: function minLength(min) {
      return function (value) {
        return value && value.length < min ? t('Must be {{a}} characters or more', {
          a: min
        }) : undefined;
      };
    },
    isValidPhone: function isValidPhone(value) {
      return (0, _libphonenumberJs.isValidNumber)(value, _metadataMin["default"]) ? undefined : t('Must be a valid phone number');
    },
    maxFileSize: function maxFileSize(value, maxSize) {
      return value && value.file && maxSize <= value.file.size / 1024 / 1024 ? t('File size must be under {{a}}mb', {
        a: maxSize
      }) : undefined;
    },
    maxDate: function maxDate(value, _maxDate) {
      return value && value > _maxDate ? t('Date must be before {{a}}', {
        a: (0, _dateHelper.formatDate)(_maxDate)
      }) : undefined;
    },
    minDate: function minDate(value, _minDate) {
      return value && value < _minDate ? t('Date must be after {{a}}', {
        a: (0, _dateHelper.formatDate)(_minDate)
      }) : undefined;
    },
    minTime: function minTime(value, _minTime) {
      if (!value) return;
      var time = getTimeObj(value);
      var min = getTimeObj(_minTime);
      return time.hours < min.hours || time.hours === min.hours && time.minutes < min.minutes ? t('Time must be after {{a}}', {
        a: (0, _dateHelper.formatTime)(_minTime)
      }) : undefined;
    },
    maxTime: function maxTime(value, _maxTime) {
      if (!value) return;
      var time = getTimeObj(value);
      var max = getTimeObj(_maxTime);
      return time.hours > max.hours || time.hours === max.hours && time.minutes > max.minutes ? t('Time must be before {{a}}', {
        a: (0, _dateHelper.formatTime)(_maxTime)
      }) : undefined;
    }
  };
};